import React from 'react';
import { CheckIcon, BoxIcon } from 'lucide-react';
interface SelectionCardProps {
  label: string;
  selected: boolean;
  disabled: boolean;
  onClick: () => void;
  icon?: BoxIcon;
  rankNumber?: number;
}
export function SelectionCard({
  label,
  selected,
  disabled,
  onClick,
  icon: Icon,
  rankNumber
}: SelectionCardProps) {
  return <div onClick={() => !disabled && onClick()} className={`relative flex flex-col p-6 min-h-[130px] rounded-xl border-2 transition-all duration-200 ${selected ? 'border-minerva bg-minerva/5 shadow-sm' : disabled ? 'border-slate-100 bg-slate-50 opacity-50 cursor-not-allowed' : 'border-slate-200 bg-white hover:border-minerva/40 hover:shadow-sm cursor-pointer'}`} role="checkbox" aria-checked={selected} tabIndex={disabled ? -1 : 0} onKeyDown={e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (!disabled) onClick();
    }
  }} data-id="element-59">
      <div className="flex justify-between items-start mb-4" data-id="element-60">
        {Icon ? <div className={`p-2 rounded-lg ${selected ? 'bg-minerva/10 text-minerva' : 'bg-slate-100 text-slate-500'}`} data-id="element-61">
              <Icon className="w-6 h-6" strokeWidth={1.5} data-id="element-62" />
            </div> : <div data-id="element-63" /> // Spacer if no icon
      }
        <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${selected ? 'border-minerva bg-minerva' : 'border-slate-300 bg-white'}`} data-id="element-64">
          {selected && rankNumber !== undefined ? <span className="text-white text-xs font-bold" data-id="element-65">{rankNumber}</span> : selected ? <CheckIcon className="w-4 h-4 text-white" strokeWidth={3} data-id="element-66" /> : null}
        </div>
      </div>
      <span className={`mt-auto font-medium text-lg leading-snug ${selected ? 'text-navy' : 'text-slate-700'}`} data-id="element-67">
        {label}
      </span>
    </div>;
}